module.exports = __webpack_public_path__ + "media/images/wines/muscat-petit-grain/bottle-detail-fe287de72f52a7f13bf88a2cdea2fe78.png";